import { createFileRoute } from '@tanstack/react-router'
import { readingJournalEntries } from '../data/reading-journal'
import { TiArrowLeftThick } from 'react-icons/ti'

export const Route = createFileRoute('/reading-journal')({
  component: ReadingJournal,
})

function ReadingJournal() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="mb-6">
          <a href="/" className="text-blue-600 hover:text-blue-800 flex items-center gap-2"><TiArrowLeftThick /> Home</a>
        </div>
        
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Reading Journal</h2>
        
        <div className="space-y-8">
          {readingJournalEntries.map((book, index) => (
            <article key={index} className="border-b border-gray-200 pb-8 last:border-b-0">
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {book.url ? (
                  <a 
                    href={book.url}
                    className="text-blue-600 hover:text-blue-800"
                    target={book.url.startsWith('http') ? '_blank' : undefined}
                    rel={book.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    {book.title}
                  </a>
                ) : (
                  book.title
                )}
              </h3>
              <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4">
                <span className="font-medium">Author: {book.author}</span>
                <span>Read: {book.date}</span>
              </div>
              
              {book.content && (
                <div className="prose prose-gray max-w-none">
                  {book.content}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
